'use client';

import { useState } from 'react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useTheme } from 'next-themes';
import { LogOut, Menu } from 'lucide-react';
import { useTranslations } from '@/hooks/useTranslations';
import { LogoutButton } from '@/features/auth/logout-button';
import { AccountMenu } from './account-menu';
import { LanguageMenu } from './language-menu';
import { ThemeMenu } from './theme-menu';
import { ExtendedUser } from '@/types/next-auth';

export default function HamburgerMenu({ user }: { user?: ExtendedUser }) {
  const t = useTranslations('Navigation');
  const [isOpen, setIsOpen] = useState(false);
  const { setTheme } = useTheme();

  // if (!user) return <>Loading</>;

  return (
    <div className={`flex ${user && `sm:hidden`}`}>
      <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" className="p-0" aria-label="Navigation menu">
            <Menu className="w-8 h-8" />
          </Button>
        </DropdownMenuTrigger>

        <DropdownMenuContent className="min-w-48 -translate-x-1.5 md:-translate-x-12">
          {user && <AccountMenu t={t} user={user} />}

          <LanguageMenu />

          <ThemeMenu setTheme={setTheme} />

          {user && (
            <>
              <DropdownMenuSeparator />

              <LogoutButton>
                <DropdownMenuItem className="cursor-pointer">
                  <LogOut className="w-5 h-5" />
                  {t('logOut')}
                </DropdownMenuItem>
              </LogoutButton>
            </>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
